import { render, staticRenderFns } from "./EstadoCuentaTotal.vue?vue&type=template&id=6fc99b48"
import script from "./EstadoCuentaTotal.vue?vue&type=script&lang=js"
export * from "./EstadoCuentaTotal.vue?vue&type=script&lang=js"
import style0 from "./EstadoCuentaTotal.vue?vue&type=style&index=0&id=6fc99b48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports